<section class="panel-card" *ngIf="esRolInvitacion; else noDisponibleTpl">
  <div class="panel-head">
    <div>
      <h2>{{ encabezadoPanel }}</h2>
      <p class="lead">{{ leadPanel }}</p>
    </div>
    <span class="count-chip">{{ invitaciones.length }} invitaciones</span>
  </div>

  <div class="table-wrap" *ngIf="invitaciones.length > 0; else emptyTpl">
    <table class="table">
      <thead>
        <tr>
          <th>ID Postulacion</th>
          <th>Concurso</th>
          <th>Proyecto</th>
          <th *ngIf="esRolPostulante">Participacion solicitada</th>
          <th>Subdireccion</th>
          <th class="status-col">Estado</th>
          <th>Acciones</th>
        </tr>
      </thead>
      <tbody>
        <tr *ngFor="let item of invitacionesPaginadas">
          <td>{{ item.idPostulacion }}</td>
          <td>{{ item.concurso }}</td>
          <td>{{ item.proyecto }}</td>
          <td *ngIf="esRolPostulante">{{ item.tipoParticipacion || 'Participacion general' }}</td>
          <td>{{ item.subdireccion }}</td>
          <td class="status-col">
            <span class="badge" [ngClass]="claseEstado(item)">{{ etiquetaEstado(item) }}</span>
          </td>
          <td class="actions">
            <ng-container *ngIf="item.estadoRespuesta === 'pendiente'; else estadoRespondidoTpl">
              <ng-container *ngIf="!puedeEditarBorrador(item); else editarBorradorTpl">
                <button
                  type="button"
                  class="text-action success"
                  (click)="responder(item, 'aceptada')"
                >
                  Aceptar
                </button>
              </ng-container>
              <ng-template #editarBorradorTpl>
                <button
                  type="button"
                  class="text-action"
                  (click)="abrirModalRecomendacion(item)"
                >
                  Editar borrador
                </button>
              </ng-template>
              <button
                type="button"
                class="text-action danger"
                (click)="responder(item, 'rechazada')"
              >
                Rechazar
              </button>
            </ng-container>

            <ng-template #estadoRespondidoTpl>
              <span class="history-note">
                {{
                  item.estadoRespuesta === 'aceptada'
                    ? (esRolRecomendador ? 'Carta enviada' : 'Asociado al proceso')
                    : 'Registro historico'
                }}
              </span>
            </ng-template>
          </td>
        </tr>
      </tbody>
    </table>
  </div>

  <ng-template #emptyTpl>
    <div class="empty-state">
      <h3>No hay invitaciones disponibles</h3>
      <p>{{ mensajeSinInvitaciones }}</p>
    </div>
  </ng-template>

  <app-table-pagination
    [page]="paginaActual"
    [pageSize]="cantidadPorPagina"
    [totalItems]="invitaciones.length"
    itemLabel="invitaciones"
    [pageSizeOptions]="opcionesCantidad"
    (pageChange)="cambiarPagina($event)"
    (pageSizeChange)="cambiarCantidadDesdePaginador($event)"
  ></app-table-pagination>

  <p class="feedback" *ngIf="mensajeAccion">{{ mensajeAccion }}</p>
</section>

<div class="modal-backdrop" *ngIf="modalRecomendacionVisible">
  <div class="modal-card" role="dialog" aria-modal="true" aria-label="Formulario de recomendacion">
    <h3>Formulario de recomendacion</h3>
    <p class="modal-lead" *ngIf="invitacionActiva as item">
      Completa la recomendacion para la postulacion <strong>{{ item.idPostulacion }}</strong>. Puedes guardar el avance y continuar despues.
    </p>

    <label class="field">
      <span>Resumen</span>
      <textarea [(ngModel)]="recomendacionForm.resumen" rows="4"></textarea>
    </label>

    <label class="field">
      <span>Fortalezas</span>
      <textarea [(ngModel)]="recomendacionForm.fortalezas" rows="4"></textarea>
    </label>

    <label class="field">
      <span>Recomendacion final</span>
      <textarea [(ngModel)]="recomendacionForm.recomendacionFinal" rows="4"></textarea>
    </label>

    <div class="modal-actions">
      <button type="button" class="btn-secondary" (click)="guardarRecomendacion()">Guardar</button>
      <button type="button" class="btn-primary" (click)="enviarRecomendacion()">Enviar</button>
    </div>
  </div>
</div>

<ng-template #noDisponibleTpl>
  <section class="panel-card empty-state">
    <h2>Modulo en preparacion para este rol</h2>
    <p>La vista especifica de invitaciones para este perfil no esta disponible en la version actual.</p>
  </section>
</ng-template>
